const { Component, h } = require('preact');

class Loading extends Component {
  render() {
    return <div className="loading loading-lg">Loading...</div>;
  }
}

module.exports = Loading;
